export enum FeatureName {
  CREATIONS = 'creations',
  ASSETS = 'assets'
}
